import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DefaultLayout from "@/layouts/default-layout";
import ActiveMeetsComp from "@/components/v2/active-meets-comp";

const ActiveMeetingsPage = () => {
  const { short_code } = useParams();
  return (
    <div className="relative bg-accent h-screen w-screen">
      <ActiveMeetsComp _short_code={short_code} />
    </div>
  );
};

export default ActiveMeetingsPage;
